var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.isEquipment !== 'phone')?_c('div',{staticClass:"Nav"},[_c('Navigation')],1):_c('div',{staticClass:"Nav"},[_c('NavigationPhone')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }